import { camelCase, capitalize, get } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import uuidv1 from 'uuid/v1'

export const multiSectionConverter = (sectionItem) => {
  const eventList = get(sectionItem, 'eventlist', [])
  const { onContentEvent, onViewMoreEvent } = getEventListByType(eventList)
  let section = {
    bgColor: get(sectionItem, 'bg_color', ''),
    bgImage: get(sectionItem, 'bg_image', ''),
    cellType: capitalize(camelCase(get(sectionItem, 'cell_type', ''))),
    forceRefresh: get(sectionItem, 'force_refresh', 'n') === 'y',
    icon: get(sectionItem, 'icon', ''),
    note: get(sectionItem, 'note', ''),
    title: get(sectionItem, 'title', ''),
    eventListPlainObjectList: eventList,
    contentEvent: onContentEvent,
    viewMoreEvent: onViewMoreEvent
  }
  if (section.title === '') {
    section.title = uuidv1()
  }
  return section
}

export const GNBDataConverter = (gnbJson) => {
  return {
    note: get(gnbJson, 'note', ''),
    type: gnbJson.type,
    version: gnbJson.version,
    genTime: get(gnbJson, 'gen_time', `${Math.random()}`),
    multiSectionList: get(gnbJson, 'multisectionlist', []).map((sectionItem) => {
      return multiSectionConverter(sectionItem)
    })
  }
}
